document.addEventListener('DOMContentLoaded', function() {
    var popup = document.getElementById('pe-subscribe-popup');
    var closeBtn = document.querySelector('.pe-close-popup');

    function showPopup() {
        var scrollY = window.scrollY || document.documentElement.scrollTop;
        var triggerHeight = document.body.offsetHeight / 4; // Adjust if needed
        if (scrollY > triggerHeight && !sessionStorage.getItem('popupClosed')) {
            popup.style.display = 'block';
        }
    }

    window.addEventListener('scroll', showPopup);

    closeBtn.addEventListener('click', function() {
        popup.style.display = 'none';
        sessionStorage.setItem('popupClosed', 'true');
    });

    // Close popup when clicking outside of it
    document.addEventListener('click', function(event) {
        if (!popup.contains(event.target)) {
            popup.style.display = 'none';
            sessionStorage.setItem('popupClosed', 'true');
        }
    });

    // Close popup when pressing escape
    window.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            popup.style.display = 'none';
            sessionStorage.setItem('popupClosed', 'true');
        }
    });
});